<label class="int-switch">
  <input
    type="checkbox"
    class="int-switch__field"
    [class]="readonly ? 'readonly': ''"
    (change)="handleChange($event)"
    [checked]="checked"
    [disabled]="disabled"
    [intAttrBinding]="[
      {attr: testingMarkers.mark, value: fieldTestMark},
      {attr: testingMarkers.defaultValue, value: fieldAddedTestMark}
    ]"
  >
  <div class="int-switch__view-box">
    <div class="int-switch__view-plug"></div>
  </div>
  <span class="int-switch__label">
    <ng-content></ng-content>
  </span>
</label>
